<template>
  <Head title="Report Group Builder" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <report-group-list :report-groups="reportGroups" :report-pages="reportPages"></report-group-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  reportGroups: Array,
  reportPages: Array
});
</script>
